<template>
    <v-group>
        <v-text
                ref="text"
                :config="textConfig"
                @dblclick="$emit('edit')"
        ></v-text>

        <v-text note="size units" :config="unitsConfig"></v-text>

        <v-line :config="indicatorConfig"></v-line>
    </v-group>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "HemSize",

        props: [
            'size',
            'connectionPoint',
            'angle',
            'flip',
            'color',
        ],

        emits: [
            'edit'
        ],

        data() {
            return {
                textWidth: 0,
            }
        },

        computed: {
            ...mapGetters('editor', [
                'getFootsInFractions',
            ]),

            rotation() {
                return this.flip ? this.angle : 360 - this.angle;
            },

            textConfig() {

                // we set width of the text field the same with the line width
                // and just set text align center
                // use Math.max for 'no-wrap' the text on beginning
                let width = Math.max(this.textWidth, 14);

                let x = width/2;
                let scaleY = this.flip ? -1 : 1;

                let text = this.getFootsInFractions(this.size);

                return {
                    x: x + 35,
                    y: 8,
                    text,
                    fontSize: 16,
                    fontFamily: 'Arial',
                    fontStyle: 'bold',
                    fill: this.color,
                    offsetX: width/2, // to center the text
                    offsetY: 8,
                    rotation: this.rotation,
                    scaleY,
                    // use text shadow to make contrast on the dark background, e.g. dark paint brush
                    shadowColor: 'white',
                    shadowOffset: { x: 1, y: 1 },
                    shadowOpacity: 0.3,
                }
            },

            unitsConfig() {
                return {
                    x: this.textConfig.x,
                    y: this.textConfig.y,
                    text: '"',
                    fontSize: 16,
                    fontFamily: 'Arial',
                    // fontStyle: 'bold',
                    fill: this.color,
                    offsetX: this.textConfig.offsetX - this.textWidth,
                    offsetY: this.textConfig.offsetY,
                    rotation: this.rotation,
                    scaleY: this.textConfig.scaleY,
                    // use text shadow to make contrast on the dark background, e.g. dark paint brush
                    shadowColor: 'white',
                    shadowOffset: { x: 1, y: 1 },
                    shadowOpacity: 0.3,
                }
            },

            indicatorConfig() {
                let points = [
                    5, 4,
                    33, 4,
                ];

                return {
                    points,
                    stroke: '#555',
                    strokeWidth: 1,
                    listening: false,
                }
            },

            textRef() {
                // get the object node to work with its properties
                return this.$refs.text?.getNode() || {};
            },

        },

        methods: {
            setTextWidth() {
                // get the correct width of the rendered text
                this.textWidth = this.textRef.getTextWidth();
            },

        },

        watch: {
            size() {
                // use $nextTick to wait for rendering
                this.$nextTick(this.setTextWidth);
            },
        },

        mounted() {
            this.setTextWidth();
        },

    }
</script>

<style scoped>

</style>